module.exports = __webpack_public_path__ + "static/media/close-ic.b087945b.svg";